import React from 'react'
import uuid from 'react-id-generator'
import TBody from '../ComparisonTableItem/ComparisonTableItem'

export default ({cards}) => <TBody cards={cards} key={uuid()} />